module.exports = __webpack_public_path__ + "static/media/email-marketing.8c018511.svg";